import { createAction } from '@'
import FetchMappingCoverage, { notifyWrite } from './FetchMappingCoverage'
import GetRegionCoverage from './GetRegionCoverage'
import { $regionCoverageQuery } from '../stores'

export default createAction('CreateRegionMapping', async body => {
    const data = await FetchMappingCoverage({ method: 'POST', path: '/region', data: body })
    notifyWrite(
        `Region ${body.region_id}: ${data.inserted || 0} hotel(s) added, ${data.skipped_existing || 0} already mapped`,
        data
    )
    const query = $regionCoverageQuery.getState()
    await GetRegionCoverage(
        query && query.region_id === body.region_id ? query : { region_id: body.region_id, page: 1 }
    )
    return data
})
